import React, { useMemo } from 'react'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe, type Stripe } from '@stripe/stripe-js'

let stripePromise: Promise<Stripe | null> | null = null

function getStripe() {
  if (stripePromise) return stripePromise
  const key = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
  if (!key) {
    console.error('VITE_STRIPE_PUBLISHABLE_KEY is not set. Stripe will not load.')
    return null
  }
  // @ts-expect-error -- developerTools is valid but not yet in @stripe/stripe-js types
  stripePromise = loadStripe(key, { developerTools: { assistant: { enabled: false } } })
  return stripePromise
}

interface StripeProviderProps {
  clientSecret?: string
  children: React.ReactNode
}

const appearance = {
  theme: 'stripe' as const,
  variables: {
    colorPrimary: '#00A79D',
    colorBackground: '#ffffff',
    colorText: '#1e293b',
    colorDanger: '#ef4444',
    fontFamily: 'Inter, system-ui, sans-serif',
    borderRadius: '8px',
  },
}

export const StripeProvider: React.FC<StripeProviderProps> = ({ clientSecret, children }) => {
  const stripe = useMemo(() => getStripe(), [])

  if (!stripe) {
    return <>{children}</>
  }

  const options = clientSecret
    ? { clientSecret, appearance }
    : { appearance }

  return (
    <Elements stripe={stripe} options={options}>
      {children}
    </Elements>
  )
}

export default StripeProvider
